import { Table } from 'react-bootstrap';
import type { ChartSlice } from '../../lib/overview-stats';
import { formatFaNumber } from '../../lib/utils';

export function CoverageBreakdownTable({
  rows,
  total,
  onRowClick,
}: {
  rows: ChartSlice[];
  total: number;
  onRowClick?: (row: ChartSlice) => void;
}) {
  if (rows.length === 0) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center gap-2 text-center text-secondary border border-dashed rounded-3 bg-body-tertiary py-4">
        <span>هنوز بازرسی ثبت نشده</span>
      </div>
    );
  }

  return (
    <div className="overview-table-wrap">
      <Table className="overview-table mb-0" responsive hover>
        <thead>
          <tr>
            <th>وضعیت</th>
            <th className="text-end">تعداد</th>
            <th className="text-end">درصد</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.id}
              className={onRowClick ? 'overview-table-row--clickable' : undefined}
              role={onRowClick ? 'link' : undefined}
              tabIndex={onRowClick ? 0 : undefined}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              onKeyDown={
                onRowClick
                  ? (e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onRowClick(row);
                      }
                    }
                  : undefined
              }
            >
              <td>
                <span className="overview-table-state">
                  <span
                    className="overview-table-swatch"
                    style={{ background: row.color }}
                    aria-hidden
                  />
                  <span className="overview-table-label">{row.label}</span>
                </span>
              </td>
              <td className="text-end overview-table-num">
                {formatFaNumber(row.value)}
              </td>
              <td className="text-end overview-table-num text-secondary">
                {formatFaNumber(row.pct)}٪
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className="fw-semibold">جمع</td>
            <td className="text-end fw-semibold overview-table-num">
              {formatFaNumber(total)}
            </td>
            <td />
          </tr>
        </tfoot>
      </Table>
    </div>
  );
}
